<template>
  <div id="searchResults">
    <h2>Search Results</h2>
    <div class="searchResultContainer" v-for="match in searchMatches" :key="'searchMatch-' + match.id">
      <div class="searchHeading" v-html="$options.filters.highlight(match.question_text, searchQuery)" @click="changeModuleQuestion(match)"></div>
      <div class="searchBody" v-for="(bodyMatch, index) in match.question_body" v-html="$options.filters.highlight(bodyMatch, searchQuery)" :key="'bodyMatch-' + bodyMatch.id + '-' + index"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SearchResults',
  props: {
    
  },
  computed: {
    ...mapGetters([
      'mobileMentorQuestions',
      'searchQuery',
      'searchMatches',
    ])
  },
  methods: {
    ...mapActions([
      'changeModuleQuestion',
    ]),
  },
  filters: {
    highlight(value, search){
      if(!value){
        return '';
      }
      var iQuery = new RegExp(search, "ig");
      return value.toString().replace(iQuery, matchedTxt => {
        return ('<span class=\'highlight\'>' + matchedTxt + '</span>');
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #searchInputContainer{
    position: relative;
    float: left;
    display: flex;
    align-items: center;
    margin-left: 15px;
  }
  #search{
    cursor: pointer;
  }
  #searchInputContainer > input{
    background-color: #304b8d;
    color: #ffffff;
    border: none;
    border-bottom: 1px solid white;
    margin-left: 10px;
    outline: none;
    font-size: 16px;
  }
  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: rgba(255,255,255,0.5);
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(255,255,255,0.5);
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(255,255,255,0.5);
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(255,255,255,0.5);
  }
  ::-ms-input-placeholder{ /* Microsoft Edge */
    color: rgba(255,255,255,0.5);
  }
  ::placeholder { /* Most modern browsers support this now. */
    color: rgba(255,255,255,0.5);
  }

  #searchResults{
    position: relative;
    top: 50px;
    background-color: #ffffff;
    z-index: 4;
    width: 80%;
    height: calc(100% - 100px);
    margin: 0 auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    padding: 25px;
  }
  .searchResultContainer{
    border-bottom: 6px solid #f3f5f4;
    padding: 10px 0px;
  }
  .searchHeading{
    color: #0084b9;
    text-decoration: underline;
    cursor: pointer;
  }
  .searchBody::before{
    content: '"';
  }
  .searchBody::after{
    content: '"';
  }
  .highlight{
    background-color: rgba(0, 85, 128, 0.2);
  }

  @media(max-width: 900px){
    #searchResults{
      width: 100%;
      height: 100%;
    }
  }

  @media(max-width: 667px){
    #searchInputContainer > input{
      width: 100px;
    }
  }
</style>
